function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "st0",
  d: "M17,12h-2v3h-3v2h3v3h2v-3h3v-2h-3V12z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  className: "st0",
  d: "M18.1,1H1.9C1.4,1,1,1.4,1,1.9v16.2C1,18.5,1.4,19,1.9,19H9v-2H3V3h14v6h2V1.9 C19,1.4,18.5,1,18.1,1z M15,5H9v2h6V5z M5,5h2v2H5V5z M7,9H5v2h2V9z M5,13h2v2H5V13z"
});

var SvgInventoryToOngoingStorageJob = function SvgInventoryToOngoingStorageJob(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInventoryToOngoingStorageJob, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inventory_to_ongoing_storage_job.c13bb728.svg";
export { ForwardRef as ReactComponent };